<template>
  <div>
    <link href="../../static/distribution-musical/css/plugins.css" rel="stylesheet" type="text/css" media="all">
    <link href="../../static/distribution-musical/css/theme.css" rel="stylesheet" type="text/css" media="all">
    <link href="../../static/distribution-musical/css/custom.css" rel="stylesheet" type="text/css" media="all">
    <link href='https://fonts.googleapis.com/css?family=Open+Sans:400,300%7CMontserrat:400,700%7CRaleway:400,200,300' rel='stylesheet' type='text/css'>
    <!-- Hero Slider -->
    <section class="hero-fullscreen" style="height:100vh;">
        <div class="hero-slider hero-parallax-fullscreen owl-carousel navigation-thin">
          <!-- Slide 1 -->
          <div class="slide bg-attraction">
            <div class="hero-container container">
              <div class="hero-content scroll-opacity">
                <div class="appear container text-center">
                  <a class="logo-dark" href="/">
                    <img src="https://indiefy.net/static/img/logo_white_new.png" alt="logo-indiefy" style="max-width:230px">
                  </a>
                  <p class="subheading white mt40" v-if="lang === 'es'">Distribucion musical para todos</p>
                  <p class="subheading white mt40" v-else>MUSIC DISTRIBUTION FOR EVERYONE</p>
                  <h1 class="lg-heading white mb40" v-if="lang === 'es'">Vende tu<br>M&uacute;sica</h1>
                  <h1 class="lg-heading white mb40" v-else>Sell your<br>Music</h1>
                  <p class="white hidden-xs attrac-description" v-if="lang === 'es'">
                    Nos especializamos en distribuci&oacute;n musical y desarrollo de artistas, publica tu m&uacute;sica con confianza,
                    utilizamos tecnolog&iacute;a de punta para ofrecer lo m&aacute;s est&aacute;ndares de distribuci&oacute;n.
                  </p>
                  <p class="white hidden-xs attrac-description" v-else>
                    We specialize in music distribution and artist development, release your music with confidence, we use top-end
                    technology to deliver the highest standards in distribution.
                  </p>
                  <a href="login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-if="lang === 'es'">Reg&iacute;strate gratis</a>
                  <a href="login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-else>Register for free</a>
                </div>
              </div>
            </div>
          </div>
          <!-- End Slide 1 -->
        </div>
    </section>
    <!-- End Hero Slider -->
    <div class="site-wrapper">
      <!-- Start Features -->
      <section class="py-4 bg-light">
        <div class="container py-4">
          <div class="text-center section-heading">
            <h3>
              {{ $t('looking_for_more') }}
            </h3>
            <p class="text-dark pro-description">
              {{ $t('boost_with_pro_ai') }}
            </p>
            <div class="mb-2">
              <router-link to="/pro?utm_campaign=free-page&utm_source=free-landing&utm_medium=landing" class="btn btn-ghost-pink btn-lg">
                Indiefy PRO
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <section id="features">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center section-heading mb20" v-if="lang === 'es'">
              <h5><b>Preguntas Frecuentes</b></h5>
              <h3>¿C&oacute;mo funciona?</h3>
              <p>La plataforma es muy simple de utilizar, sube tu musica en 5 minutos o menos, sin problemas.</p>
            </div>
            <div class="col-md-12 text-center section-heading mb20" v-else>
              <h5><b>COMMON QUESTIONS</b></h5>
              <h3>How does it work?</h3>
              <p>The platform has the most simple interface, upload your music in 5 minutes or less, hassle-free.</p>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span>1</span>
              </div>
              <div class="feature-info">
                <h4>Reg&iacute;strate en la plataforma</h4>
                <p>Elige tu forma de acceso ya sea con redes sociales o con tu correo electr&oacute;nico.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span>1</span>
              </div>
              <div class="feature-info">
                <h4>Register and login</h4>
                <p>Choose your form of access either with social networks or with your email.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span>2</span>
              </div>
              <div class="feature-info">
                <h4>Selecciona tu membres&iacute;a</h4>
                <p>Contamos con 2 tipos de membres&iacute;as: Basic y Pro. <b>La cuenta Basic es gratuita</b>
                mientras que la PRO tiene m&aacute;s beneficios y cuesta tan solo 4.16USD al mes.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span>2</span>
              </div>
              <div class="feature-info">
                <h4>Select your membership</h4>
                <p>We have 2 types of memberships: Basic and Pro. <b>The Basic account is free</b> while the PRO has
                  more benefits and costs only 4.16USD per month.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span>3</span>
              </div>
              <div class="feature-info">
                <h4>Crea y verifica tu artista</h4>
                <p>Crear tu artista te lleva menos de 3 minutos, una vez creado tu artista podr&aacute;s comenzar a
                  distribuir tu contenido mientras verificamos tu informaci&oacute;n.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span>3</span>
              </div>
              <div class="feature-info">
                <h4>Create and verify your artist</h4>
                <p>Creating your artist takes less than 3 minutes, once your artist is created you can start distributing
                  your content while we verify your information.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span>4</span>
              </div>
              <div class="feature-info">
                <h4>Crea tu lanzamiento</h4>
                <p>Crear un lanzamiento lleva menos de 5 minutos, sigue los pasos que te iremos indicando para finalizar
                  con el proceso de env&iacute;o.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span>4</span>
              </div>
              <div class="feature-info">
                <h4>Create your release</h4>
                <p>Creating a release takes less than 5 minutes, follow the steps that we will indicate you to finish the submission process.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span>5</span>
              </div>
              <div class="feature-info">
                <h4>Llena tus datos de pago</h4>
                <p>Una vez enviado tu lanzamiento llena tus datos de pago, selecciona el método que más te convenga,
                  comenzaremos a reportar tus primeros reportes a los 3 meses.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span>5</span>
              </div>
              <div class="feature-info">
                <h4>Fill out your payment information</h4>
                <p>Once your release has been sent, fill in your payment information, select the method that suits you
                  best, we will begin to report your first reports after 3 months.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span>6</span>
              </div>
              <div class="feature-info">
                <h4>Revisa tus anal&iacute;ticos y cobra</h4>
                <p>Podr&aacute;s ir monitoreando tus ventas y streams dentro de la plataforma hasta el dia que est&eacute; listo
                  tu pago de regal&iacute;as.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span>6</span>
              </div>
              <div class="feature-info">
                <h4>Check your analytics and withdraw</h4>
                <p>You will be able to monitor your sales and streams within the platform until the day your royalty payment is ready.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Features -->
      <!-- Start About -->
      <section class="pt70 pb70 static about-us">
        <div class="container">
          <div class="vertical-align">
            <div class="col-md-12 col-lg-6 text-md-center text-lg-left section-heading mt40 mb40" v-if="lang === 'es'">
              <h5 class="mt10">SOBRE NOSOTROS</h5>
              <h3 class="underline-left">¿Qu&eacute; somos?</h3>
              <p>
                Nuestra principal misi&oacute;n es asistir al artista independiente, todos nuestros esfuerzos giran en torno al artista,
                siempre estamos buscando las estrategias, conexiones y facilitamos herramientas adecuadas para poder hacerlo.
              </p>
            </div>
            <div class="col-md-12 col-lg-6 text-md-center text-lg-left section-heading mt40 mb40" v-else>
              <h5 class="mt10">ABOUT US</h5>
              <h3 class="underline-left">What are we?</h3>
              <p>
                Our main mission is to assist the independent artist, all our efforts revolve around the artist, we're always looking for
                strategies, connections and we provide adequate tools to do so.
              </p>
            </div>
            <div class="col-md-12 col-lg-6 mt40 mb40">
              <div class="video-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/93IodhE3qvA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End About Section -->
      <!-- Start Fun Facts Section -->
      <section class="pt10">
        <div class="container">
          <div class="counter-row row text-center wow fadeInUp">
            <div class="col-md-3 col-sm-6 fact-container">
              <div class="fact">
                <span class="counter i-primary">164</span>
                <h4 v-if="lang === 'es'"># Pa&iacute;ses con presencia</h4>
                <h4 v-else># Countries</h4>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 fact-container">
              <div class="fact">
                <span class="counter i-primary">32</span>
                <h4 v-if="lang === 'es'"># Tiendas digitales</h4>
                <h4 v-else># Stores</h4>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 fact-container">
              <div class="fact">
                <span class="counter i-primary">{{ Number(parseInt(totalDistros)).toLocaleString().replace('.', ',') }}</span>
                <h4 v-if="lang === 'es'"># Canciones</h4>
                <h4 v-else># Songs</h4>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 fact-container">
              <div class="fact">
                <span class="counter i-primary">{{ Number(parseInt(totalUsers)).toLocaleString().replace('.', ',') }}</span>
                <h4 v-if="lang === 'es'"># Usuarios</h4>
                <h4 v-else># Users</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Fun Facts Section -->
      <!-- Testimonials Slider -->
      <section id="testimonials" class="pt130 pb90 parallax bg-testimonials">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center section-heading">
              <h5 class="white underline-center" v-if="lang === 'es'">TESTIMONIALES</h5>
              <h5 class="white underline-center" v-else>TESTIMONIALS</h5>
            </div>
            <div class="visible-lg-block col-lg-2">&nbsp;</div>
            <div class="col-md-12 col-lg-8 text-center">
              <div id="owl-testimonials" class="owl-carousel light-pagination">
                <!-- Testimonial 1 -->
                <div class="testimonial-slide">
                  <span v-if="lang === 'es'">
                    <p>"Amo Indiefy, realmente están ahi para m&iacute;, es mi distribuidora de confianza!"</p>
                    <h4 class="highlight">KENIA OS <img src="../../static/img/countries/MX.png" class="country"><br>2.6m escuchas mensuales en Spotify</h4>
                  </span>
                  <span v-else>
                    <p>"I love Indiefy, they're really there for me, it's my trusted distributor!"</p>
                    <h4 class="highlight">KENIA OS <img src="../../static/img/countries/MX.png" class="country"><br>2.6m monthly listeners on Spotify</h4>
                  </span>
                  <a href="https://open.spotify.com/artist/31VFEohvhOUKrtAONEBhMG?si=MBCiEGjnS1KGBzXY4PTsdA&dl_branch=1" target="_blank">
                    <i class="fab fa-spotify"></i>
                  </a>
                  <a href="https://www.youtube.com/channel/UCSEY-xdBrV-J1zpLg9-mr6w" target="_blank" class="mr-2 ml-2">
                    <i class="fab fa-youtube"></i>
                  </a>
                  <a href="https://www.instagram.com/keniaos" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                </div>
                <!-- Testimonial 2 -->
                <div class="testimonial-slide">
                  <span v-if="lang === 'es'">
                    <p>"Ninguna otra distribuidora me había dado la oportunidad de interacción, puedes sentarte
                      con ellos y hablar de tus proyectos, confío en ellos, crecemos juntos."</p>
                    <h4 class="highlight">ALEGRES DE LA SIERRA <img src="../../static/img/countries/MX.png" class="country"><br>1.2M escuchas mensuales en Spotify</h4>
                  </span>
                  <span v-else>
                    <p>"No other distributor has given me the opportunity to interact, you can sit down with them and
                      talk about your projects, I trust them, we grow together."</p>
                    <h4 class="highlight">ALEGRES DE LA SIERRA <img src="../../static/img/countries/MX.png" class="country"><br>1.2M monthly listeners on Spotify</h4>
                  </span>
                  <a href="https://open.spotify.com/artist/4Yfe8uXcl5PYwknQ4OMZIP?si=7lJMuF6HQtamRP2MTzLSiQ&dl_branch=1" target="_blank">
                    <i class="fab fa-spotify"></i>
                  </a>
                  <a href="https://www.youtube.com/channel/UCytGRAGWCa0ZXg68SiEoLwg" target="_blank" class="mr-2 ml-2">
                    <i class="fab fa-youtube"></i>
                  </a>
                  <a href="https://www.instagram.com/alegresdelasierra_oficial" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                </div>
                <!-- Testimonial 3 -->
                <div class="testimonial-slide">
                  <span v-if="lang === 'es'">
                    <p>"Indiefy ha sido la soluci&oacute;n para mis distribuciones desde el primer d&iacute;a, realmente se interesan por mi carrera."</p>
                    <h4 class="highlight">RHYMETOWN <img src="../../static/img/countries/TR.png" class="country"><br>9K escuchas mensuales en Spotify</h4>
                  </span>
                  <span v-else>
                    <p>"Indiefy has been the solution for my distributions since day one, they really care for my career."</p>
                    <h4 class="highlight">RHYMETOWN <img src="../../static/img/countries/TR.png" class="country"><br>9K monthly listeners on Spotify</h4>
                  </span>
                  <a href="https://open.spotify.com/artist/67qo2xGIo9uH8JhhPWetHe?si=LK5IWSPrSXOXFjJVctXymg&dl_branch=1" target="_blank">
                    <i class="fab fa-spotify"></i>
                  </a>
                  <a href="https://www.youtube.com/c/RhymetownOfficial" target="_blank" class="mr-2 ml-2">
                    <i class="fab fa-youtube"></i>
                  </a>
                  <a href="https://www.instagram.com/rhymetownyapim" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="visible-lg-block col-lg-2">&nbsp;</div>
          </div>
        </div>
      </section>
      <!-- End Testimonials Slider -->
      <!-- Team Section -->
      <section class="pt130 pb100">
        <div class="container">
          <div class="row text-center">
            <div class="col-md-12 text-center section-heading mb50" v-if="lang === 'es'">
              <h5><b>ALGUNOS DE NUESTROS ARTISTAS</b></h5>
              <h3>¿Qui&eacute;n utiliza Indiefy?</h3>
            </div>
            <div class="col-md-12 text-center section-heading mb50" v-else>
              <h5><b>SOME OF OUR ARTISTS</b></h5>
              <h3>Who uses Indiefy?</h3>
            </div>
            <div class="col-md-4 team-col">
              <div class="team-member">
                <div class="team-member-image">
                  <img src="../../static/distribution-musical/img/kenia-os.jpg" class="img-responsive" alt="" />
                  <div class="team-member-detail hover-bottom">
                    <ul>
                      <li class="social-icon">
                        <a href="https://open.spotify.com/artist/31VFEohvhOUKrtAONEBhMG?si=MBCiEGjnS1KGBzXY4PTsdA&dl_branch=1" target="_blank">
                          <i class="icon-social-spotify"></i>
                        </a>
                      </li>
                      <li class="social-icon">
                        <a href="https://www.youtube.com/channel/UCSEY-xdBrV-J1zpLg9-mr6w" target="_blank">
                          <i class="icon-social-youtube"></i>
                        </a>
                      </li>
                      <li class="social-icon">
                        <a href="https://www.instagram.com/keniaos" target="_blank">
                          <i class="icon-social-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="member-info text-left" v-if="lang === 'es'">
                <h4>Kenia OS <img src="../../static/img/countries/MX.png" class="country">
                  <small>Artista / Emprendedora / Influencer</small>
                </h4>
                <p>
                  Kenia Guadalupe Flores Osuna, m&aacute;s conocida en el mundo digital como Kenia Os, naci&oacute; en Mazatl&aacute;n,
                  Sinaloa, M&eacute;xico el 15 de julio de 1999. En 2018 emergi&oacute; como cantante al abrir su canal "K Os" y lanzar sus
                  primeros sencillos titulados "Por Siempre" y "Bonita" que tienen m&aacute;s de 138 millones de streams.
                </p>
              </div>
              <div class="member-info text-left" v-else>
                <h4>Kenia OS <img src="../../static/img/countries/MX.png" class="country">
                  <small>Artist / Entrepeneur / Influencer</small>
                </h4>
                <p>
                  Kenia Guadalupe Flores Osuna, better known in the digital world as Kenia Os, was born in Mazatlán, Sinaloa,
                  M&eacute;xico on July 15th, 1999. In 2018 she emerged as a singer by opening her channel "K Os" and releasing her first
                  singles titled "Por Siempre" and "Bonita" which have more than 138 million streams.
                </p>
              </div>
            </div>
            <div class="col-md-4 team-col">
              <div class="team-member">
                <div class="team-member-image">
                  <img src="../../static/distribution-musical/img/los-alegres.jpg" class="img-responsive" alt="" />
                  <div class="team-member-detail hover-bottom">
                    <ul>
                      <li class="social-icon">
                        <a href="https://open.spotify.com/artist/4Yfe8uXcl5PYwknQ4OMZIP?si=7lJMuF6HQtamRP2MTzLSiQ&dl_branch=1" target="_blank">
                          <i class="icon-social-spotify"></i>
                        </a>
                      </li>
                      <li class="social-icon">
                        <a href="https://www.youtube.com/channel/UCytGRAGWCa0ZXg68SiEoLwg" target="_blank">
                          <i class="icon-social-youtube"></i>
                        </a>
                      </li>
                      <li class="social-icon">
                        <a href="https://www.instagram.com/alegresdelasierra_oficial" target="_blank">
                          <i class="icon-social-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="member-info text-left" v-if="lang === 'es'">
                <h4>Los Alegres de la Sierra <img src="../../static/img/countries/MX.png" class="country">
                  <small>Artista</small>
                </h4>
                <p>El grupo mexicano Alegres de la Sierra comenz&oacute; como un cuarteto en su natal San Blas, Sinaloa,
                  compuesto por el cantante y guitarrista Inocente Guerrero (alias Chente), el cantante y compositor
                  Manuel Guerrero, el bajista y el acordeonista Alberto Guerrero.</p>
              </div>
              <div class="member-info text-left" v-else>
                <h4>Los Alegres de la Sierra <img src="../../static/img/countries/MX.png" class="country">
                  <small>Artist</small>
                </h4>
                <p>Mexican group Alegres de la Sierra started as a foursome in their native San Blas, Sinaloa,
                  comprising singer/guitarist Inocente Guerrero (aka Chente), singer/songwriter Manuel Guerrero,
                  bassist Guillermo Guerrero, and accordionist Alberto Guerrero.</p>
              </div>
            </div>
            <div class="col-md-4 team-col">
              <div class="team-member">
                <div class="team-member-image">
                  <img src="../../static/distribution-musical/img/rhymetown.jpg" class="img-responsive" alt="" />
                  <div class="team-member-detail hover-bottom">
                    <ul>
                      <li class="social-icon">
                        <a href="https://open.spotify.com/artist/67qo2xGIo9uH8JhhPWetHe?si=LK5IWSPrSXOXFjJVctXymg&dl_branch=1" target="_blank">
                          <i class="icon-social-spotify"></i>
                        </a>
                      </li>
                      <li class="social-icon">
                        <a href="https://www.youtube.com/c/RhymetownOfficial" target="_blank">
                          <i class="icon-social-youtube"></i>
                        </a>
                      </li>
                      <li class="social-icon">
                        <a href="https://www.instagram.com/rhymetownyapim" target="_blank">
                          <i class="icon-social-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="member-info text-left" v-if="lang === 'es'">
                <h4>Rhymetown <img src="../../static/img/countries/TR.png" class="country">
                  <small>Artista / Productor de videos</small>
                </h4>
                <p>Es un grupo musical formado por "Nevfel Uluçay" en Adana, Turqu&iacute;a,  con la ideolog&iacute;a de "La propiedad intelectual es de todos".
                  Incluye m&uacute;sicos, artistas gr&aacute;ficos, beatmakers, actores y artistas que producen en muchas ramas del arte y pueden ser
                  considerados responsables en el desarrollo de este proyecto.</p>
              </div>
              <div class="member-info text-left" v-else>
                <h4>Rhymetown <img src="../../static/img/countries/TR.png" class="country">
                  <small>Artist / Video producer</small>
                </h4>
                <p>It's a musical group formed by "Nevfel Uluçay" in Adana, Turkey, with the ideology of "Intellectual property belongs to everyone".
                  It includes musicians, graphic artists, beatmakers, actors, and artists who produce in many branches of art and can be selected
                  responsible for the development of this project.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Team Section -->
      <!-- Get Connected -->
      <section id="get-connected" class="pt140 pb110 parallax bg-img-3 bg-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center section-heading" v-if="lang === 'es'">
              <h5 class="white">¿LISTO PARA COMENZAR?</h5>
              <h1 class="white">Hag&aacute;moslo oficial</h1>
            </div>
            <div class="col-md-12 text-center section-heading" v-else>
              <h5 class="white">READY TO BEGIN?</h5>
              <h1 class="white">Let’s make it official</h1>
            </div>
            <div class="col-md-12 text-center">
              <a href="/login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-if="lang === 'es'">Crear mi cuenta gratis</a>
              <a href="/login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-else>Create my free account</a>
            </div>
          </div>
        </div>
      </section>
      <!-- End Get Connected -->
      <!-- Start Footer 1 -->
      <footer id="footer-1" class="pt60 pb50">
        <div class="container">
          <div class="row">
            <div class="col-md-4">&nbsp;</div>
            <div class="col-md-4 text-center">
              <h4>About Indiefy</h4>
              <p class="footer-description">
                Indiefy is an American registered Company since 2017.<br>
                <a href="/" target="_blank">
                  © Indiefy {{ year }}
                </a>
              </p>
            </div>
            <div class="col-md-4">&nbsp;</div>
          </div>
        </div>
      </footer>
      <!-- End Footer 1 -->
    </div><!-- Site Wrapper -->
  </div>
</template>
<script>
import Blog from '../services/blog'
export default {
  name: 'ProLayout',
  lang: 'en',
  data () {
    return {
      year: new Date().getFullYear(),
      totalDistros: 61735,
      totalUsers: 149154
    }
  },
  methods: {

  },
  created: function () {
    if (this.$route.path.match('/distribucion-musical-gratis')) {
      this.lang = 'es'
    } else if (this.$route.path.match('/free-online-music-distribution')) {
      this.lang = 'en'
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    Blog.getPublicInfo().then(response => {
      if (response.data && !isNaN(response.data.total_distros) && !isNaN(response.data.total_users)) {
        this.totalDistros = response.data.total_distros
        this.totalUsers = response.data.total_users
      }
    })
  },
  mounted: function () {
    window.$('.hero-slider').owlCarousel({
      autoPlay: false,
      navigation: true,
      navigationText: [
        '<img src="../../static/distribution-musical/img/slider-left-thin-arrow.png">',
        '<img src="../../static/distribution-musical/img/slider-right-thin-arrow.png">'
      ],
      slideSpeed: 300,
      paginationSpeed: 400,
      singleItem: true,
      items: 1,
      autoHeight: true,
      addClassActive: true,
      beforeMove: function () {
        // BEFORE going to the next slide (hide captions)
      },
      afterMove: function () {
        // AFTER going to next slide (show captions)
      }
    })
    setTimeout(() => {
      window.$('#owl-testimonials').owlCarousel({
        autoPlay: false,
        singleItem: true,
        pagination: true,
        navigation: false,
        items: 1
      })

      setTimeout(() => {
        window.prerenderReady = true
      })
    }, 100)
  }
}
</script>
<style scoped>
.pro-description {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProLayout.vue